import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m13.807 6.193-4-4a.7.7 0 0 0-.214-.14.7.7 0 0 0-.26-.053H4a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V6.667a.67.67 0 0 0-.193-.474M6 3.333h2.667v1.334H6zm4 9.334H6v-2A.667.667 0 0 1 6.667 10h2.666a.666.666 0 0 1 .667.667zM12.667 12a.667.667 0 0 1-.667.667h-.667v-2a2 2 0 0 0-2-2H6.667a2 2 0 0 0-2 2v2H4A.667.667 0 0 1 3.333 12V4A.667.667 0 0 1 4 3.333h.667v2A.667.667 0 0 0 5.333 6h4A.667.667 0 0 0 10 5.333v-1.06l2.667 2.667z"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })